import getHrefParams from "../helpers/getHrefParams";

document.addEventListener("DOMContentLoaded", () => {
  const cardInfoElems = document.querySelectorAll(".card-info");
  const cardButtonElems = document.querySelectorAll(".card-info__head-button");

  // Open/close cards
  if (cardInfoElems && cardInfoElems.length) {
    cardButtonElems.forEach((btn) => {
      btn.addEventListener("click", () => {
        const parentCardInfo = btn.closest('.card-info')
        parentCardInfo?.classList.toggle('collapsed')
      });
    });

    // Scroll to active card depends on url param
    const showCardInfo = (cardInfo, scroll = false) => {
      cardInfo.classList.remove('collapsed')
      const scrollTop = cardInfo.offsetTop - 20;

      if (scroll) {
        setTimeout(() => {
          window.scrollTo({ top: scrollTop, behavior: "smooth" });
        }, 0);
      }
    };

    // Different classes for card 3 items and 4 items
    const toggleCardsClass = () => {
      cardInfoElems.forEach((cardInfoEl) => {
        const cardsContainer = cardInfoEl.querySelector(".card-info__cards");
        if (cardsContainer) {
          const cardCnt = cardsContainer.querySelectorAll(".card-info__card").length;
          if (cardCnt > 3) {
            cardsContainer.classList.add("big-items");
          }
        }
      });
    };

    toggleCardsClass();

    // Auto open card depends on url param
    let hrefParams = getHrefParams();
    if (hrefParams.card) {
      let needleCardInfo = document.querySelector(`.card-info[data-card="${hrefParams.card}"]`);
      showCardInfo(needleCardInfo);
      window.scrollTo({
        top: needleCardInfo.offsetTop - 20,
        left: 0,
        behavior: "smooth",
      });
    }
  }
});
